const reviewRoutes = {
  path: "reviews",

  // Lazy-load the layout
  lazy: async () => {
    const mod = await import(
      "components/UI/BriefcaseLayout/TestimonialsLayout.tsx/TestimonialLayout"
    );
    const TestimonialLayout =
      mod.default;
    return { Component: TestimonialLayout };
  },

  children: [
    {
      index: true,
      lazy: async () => {
        const mod = await import("views/Admin/Testimonials/MyTestimonials");
        const MyTestimonials =
          mod.default ;
        return { Component: MyTestimonials };
      },
    },
  ],
};

export default reviewRoutes;
